














import Picker from './picker.vue';
import { Component, Prop, Model, Mixins } from 'vue-property-decorator';
import FormMixin from '../../../common/mixins/formMixin';

interface PickerItem {
  label: string;
  value: string;
}
@Component({
  components: {
    Picker,
  },
})
export default class FitPicker extends Mixins(FormMixin) {
  @Prop() public placeholder!: string;
  @Prop() public title!: string;
  @Prop({ default: true }) public maskClose!: boolean;
  @Prop() public confirmBtnText!: string;
  @Prop({ default: () => [] }) public items!: PickerItem[];
  @Prop({ default: 1 }) public depth!: number;
  @Prop({ default: false }) public disabled!: boolean;
  @Model('change', { type: [String, Number, Array] })
  public readonly value!: any;

  get isMulti() {
    return +this.depth > 1;
  }

  get pickerValue() {
    return this.isMulti ? this.value : [this.value];
  }

  public change(val, label) {
    this.$emit('change', this.isMulti ? val : val[0], label.join(','));
    this.notify('change', val);
  }
}
